var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,35.5H32.1v-3H16ZM16,27H32.1V24H16ZM11,44a3.08,3.08,0,0,1-3-3V7a2.89,2.89,0,0,1,.9-2.1A2.89,2.89,0,0,1,11,4H29.05L40,15V41a3.08,3.08,0,0,1-3,3ZM27.55,16.3V7H11V41H37V16.3ZM11,7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.22dd60e99513303bd1d14bbfbdb5336b.svg";
export { ForwardRef as ReactComponent };